
  // IMPORTANT: This file was generated by tools/build.js
  // If you edit it, your changes will be overwritten once dev server restarts
  export default {
  "CONFIG_ID": "upsun:prod",
  "CUSTOM_CSP_POLICIES": {
    "connect-src": [
      "https://data.eu.pendo.io",
      "https://app.eu.pendo.io",
      "https://pendo-eu-static-4832676647075840.storage.googleapis.com"
    ],
    "font-src": [
      "https://cdn.pendo.io",
      "https://cdn.eu.pendo.io"
    ],
    "frame-src": [
      "https://app.eu.pendo.io",
      "https://portal.eu.pendo.io"
    ],
    "img-src": [
      "https://cdn.eu.pendo.io",
      "https://cdn.pendo.io",
      "https://data.eu.pendo.io",
      "https://app.eu.pendo.io"
    ],
    "script-src": [
      "https://cdn.eu.pendo.io",
      "https://pendo-eu-static.storage.googleapis.com",
      "https://data.eu.pendo.io",
      "https://app.eu.pendo.io",
      "munchkin.marketo.net",
      "static.reo.dev"
    ],
    "style-src": [
      "https://pendo-eu-static.storage.googleapis.com",
      "https://app.eu.pendo.io",
      "https://cdn.eu.pendo.io"
    ]
  },
  "CUSTOM_APP_NAME": "Upsun",
  "CUSTOM_ASSETS_URL": false,
  "CUSTOM_BLACKFIRE_CARD_LANGUAGE": [
    "php",
    "python"
  ],
  "CUSTOM_BRANDING_MESSAGE": false,
  "CUSTOM_CLI_COMMAND": "upsun",
  "CUSTOM_CONFIG_DIR_NAME": ".upsun",
  "CUSTOM_CONSOLE_TITLE": false,
  "CUSTOM_CSP": false,
  "CUSTOM_DEFAULT_BRANCH": "main",
  "CUSTOM_FEDERATED_AUTH_PROVIDERS": [
    {
      "connectUrl": "https://auth.upsun.com/auth/authorize/github-upsun?intent=connect",
      "imagePath": "images/github.svg",
      "imagePathDark": "images/github-white.svg",
      "label": "GitHub",
      "loginUrl": "https://auth.upsun.com/auth/authorize/github-upsun?intent=login",
      "name": "github",
      "signupUrl": "https://auth.upsun.com/auth/authorize/github-upsun?intent=signup"
    },
    {
      "connectUrl": "https://auth.upsun.com/auth/authorize/google?intent=connect",
      "imagePath": "images/google.svg",
      "label": "Google",
      "loginUrl": "https://auth.upsun.com/auth/authorize/google?intent=login",
      "name": "google",
      "signupUrl": "https://auth.upsun.com/auth/authorize/google?intent=signup"
    },
    {
      "connectUrl": "https://auth.upsun.com/auth/authorize/bitbucket-upsun?intent=connect",
      "imagePath": "images/bitbucket.svg",
      "label": "Bitbucket",
      "loginUrl": "https://auth.upsun.com/auth/authorize/bitbucket-upsun?intent=login",
      "name": "bitbucket",
      "signupUrl": "https://auth.upsun.com/auth/authorize/bitbucket-upsun?intent=signup"
    },
    {
      "connectUrl": "https://auth.upsun.com/auth/authorize/gitlab?intent=connect",
      "imagePath": "images/gitlab.svg",
      "label": "GitLab",
      "loginUrl": "https://auth.upsun.com/auth/authorize/gitlab?intent=login",
      "name": "gitlab",
      "signupUrl": "https://auth.upsun.com/auth/authorize/gitlab?intent=signup"
    }
  ],
  "CUSTOM_FLEXIBLE_PLAN_VALUE": "upsun/flexible",
  "CUSTOM_FOOTER_TEXT": false,
  "CUSTOM_LOGO_HEIGHT": 32,
  "CUSTOM_LOGO_WIDTH": 32,
  "CUSTOM_ORGANIZATION_VENDORS": {
    "platformsh": "https://console.platform.sh",
    "upsun": ""
  },
  "CUSTOM_PROFILING_LANGUAGE": [
    "php",
    "python",
    "golang",
    "java",
    "node",
    "ruby"
  ],
  "CUSTOM_THEME": false,
  "CUSTOM_TRIAL_STAGES": false,
  "CUSTOM_WINDOW_TITLE": "Upsun",
  "CUSTOM_AUTH_LEFT_PANEL": [
    "/register"
  ],
  "CUSTOM_COOKIE_DOMAIN": "upsun.com",
  "CUSTOM_SIMPLE_LEFT_PANEL": [
    "/"
  ],
  "CUSTOM_URL_BILLING": false,
  "CUSTOM_URL_CLI_DOWNLOAD": false,
  "CUSTOM_URL_DOCS": "https://devcenter.upsun.com",
  "CUSTOM_URL_DOCS_STATUS_CHECK": false,
  "CUSTOM_URL_PROJECT_CREATION": false,
  "CUSTOM_URL_REGISTER": "https://upsun.com/register/",
  "CUSTOM_URL_SUBSCRIPTION_DELETE_REDIRECT": false,
  "CUSTOM_URL_SUBSCRIPTION_UPGRADE": false,
  "CUSTOM_URL_SUPPORT": false,
  "CUSTOM_URL_VENDOR_CONSOLE": false,
  "CUSTOM_ERROR_SUPPORT_URL": "https://discord.gg/PkMc2pVCDV",
  "URL_ACCOUNTS": "https://accounts.platform.sh",
  "URL_ANNOUNCEMENTS": "https://platform.sh/product/announcements/upsun.json",
  "URL_API_BLACKFIRE": "https://api.blackfire.io",
  "URL_API_PROXY": "https://api.upsun.com",
  "URL_AUTH": "https://auth.upsun.com",
  "URL_DEMO_PROJECT": "https://github.com/platformsh/demo-cmd.git",
  "URL_GITHUB": "https://api.github.com",
  "URL_GITLAB": "https://gitlab.com",
  "URL_LOGOUT": "https://auth.upsun.com/auth/logout",
  "URL_REDIRECT_AFTER_LOGIN": false,
  "URL_REDIRECT_AUTH_USER": "https://console.upsun.com",
  "URL_SIA": "https://sia.upsun.com",
  "ID_API_CLIENT": "ui@upsun",
  "ID_COOKIELAW": "95022fca-0603-4adc-bcc6-010ae6852c58",
  "ID_DOCS_TOKEN": "509f11463964c0434b8281def0d4d166e55d32663c63f6f0f761b0b104c6620c",
  "ID_DRIFT_CHATBOT": "7prg3wvt49yk",
  "ID_GOOGLE_TAG_MANAGER": "GTM-NN9T4G2T",
  "ID_PENDO": "a7d1f2f1-632e-440e-51d1-584419684539",
  "ID_PENDO_AUTH": "608512d4-8044-435d-4d86-dbbf151511b8",
  "ID_PLATFORM_TREE": false,
  "ID_RECAPTCHA": "6LdtXdUUAAAAACC112Rhevm2V0WMcgVkvVbPEJDI",
  "ID_SENTRY_DNS": "https://7682ebc48eef70826bdca7ac9f08b505@o38989.ingest.us.sentry.io/4508160398852096",
  "ID_SENTRY_ORGANIZATION": "platformsh",
  "ID_SENTRY_PROJECT": "console",
  "ID_STATUS_PAGE": "l2x5n4czt1ph",
  "ID_ZENDESK": false,
  "PREVIEW_FOR_INTERNAL": [
    "ENABLE_MULTIVERSION_DEPLOYMENT"
  ],
  "DISABLE_ALL_PROJECTS": true,
  "ENABLE_ACCOUNT_SECURITY_ROUTE": true,
  "ENABLE_ADD_DOMAIN_SUPPORT": false,
  "ENABLE_ADD_PROJECT_USER_PRICING_AGREEMENT": true,
  "ENABLE_ANNOUNCEMENTS": true,
  "ENABLE_AUTOMATED_BACKUPS": false,
  "ENABLE_AUTOSCALING": true,
  "ENABLE_BILLING": true,
  "ENABLE_BLACKFIRE_CARD": true,
  "ENABLE_CARBON_EMISSIONS_DASHBOARD": false,
  "ENABLE_CHANGE_USERNAME_EMAIL": true,
  "ENABLE_COMMAND_MENU": true,
  "ENABLE_COMMAND_MENU_DOCS": true,
  "ENABLE_CONNECTED_ACCOUNTS_ROUTE": true,
  "ENABLE_CONTINUOUS_PROFILING_SELLABLE": true,
  "ENABLE_CREATE_ORGANIZATION": true,
  "ENABLE_CREATE_PROJECT": true,
  "ENABLE_CUSTOM_BANNER_MESSAGE": true,
  "ENABLE_CUSTOM_LEFT_PANEL": false,
  "ENABLE_DEPLOYMENT_OVERLAY": true,
  "ENABLE_DISCLAIMER_GENERAL_SUPPORT": false,
  "ENABLE_EDIT_PLAN": true,
  "ENABLE_ENVIRONMENT_DOMAINS": true,
  "ENABLE_ENVIRONMENT_SOCKET": true,
  "ENABLE_EXTERNAL_URL": false,
  "ENABLE_FIRST_PROJECT_INCENTIVE": true,
  "ENABLE_FREE_TRIAL_DIALOG": true,
  "ENABLE_GREEN_DISCOUNT": true,
  "ENABLE_HIPAA_COMPLIANCE": false,
  "ENABLE_HTTP_METRICS": true,
  "ENABLE_LOCAL_DEPLOYMENT_TARGET": false,
  "ENABLE_MARKETING_CHECKBOX": true,
  "ENABLE_MULTIVERSION_DEPLOYMENT": false,
  "ENABLE_NOTIFICATION_SETTINGS": true,
  "ENABLE_OBSERVABILITY_SANDBOX": true,
  "ENABLE_OBSERVABILITY_SUITE_INTEGRATIONS": true,
  "ENABLE_ORGANIZATION": true,
  "ENABLE_ORGANIZATION_FIRST_ONBOARDING": true,
  "ENABLE_ORGANIZATION_PLANS_PERMISSION": false,
  "ENABLE_ORGANIZATION_TYPE_DISPLAY": false,
  "ENABLE_PROFILING": true,
  "ENABLE_PROJECT_ACCESS_SELECT": true,
  "ENABLE_PROJECT_PROVISIONING_WIZARD": false,
  "ENABLE_PROJECT_SETUP_TIPS": true,
  "ENABLE_PROJECT_SETUP_WIZARD": false,
  "ENABLE_REACTIVATE_TRIAL": true,
  "ENABLE_REDUCED_WIZARD": false,
  "ENABLE_REGISTRATION": true,
  "ENABLE_RESET_PROFILE_PASSWORD": true,
  "ENABLE_RESOURCE_METRICS_THRESHOLD": true,
  "ENABLE_SENTRY": true,
  "ENABLE_SERVICE_TREE": true,
  "ENABLE_SINGLE_STEP_SINGUP_FLOW": true,
  "ENABLE_SOURCE_REPOSITORY_TOOLTIP": false,
  "ENABLE_STAFF_TEST_MODE": true,
  "ENABLE_STRIPE": true,
  "ENABLE_SUBSCRIBE_FLOW": true,
  "ENABLE_SUPPORT_SELLABLE": true,
  "ENABLE_SUPPORTS_RESTRICT_ROBOTS": false,
  "ENABLE_TERMS_AND_ACCEPTANCE_CHECKBOX": true,
  "ENABLE_TOTAL_RESOURCE_ALLOCATION_METRICS": true,
  "ENABLE_UNBRANDED_ILLUSTRATIONS": true,
  "ENABLE_UPDATE_PROJECT_THROUGH_SUBSCRIPTION": true,
  "ENABLE_USAGE_BASED_BILLING_PAGES": true,
  "ENABLE_VOUCHERS": true,
  "ENABLE_INTERNAL_SERVICE_METRICS": true,
  "FIXED_CUSTOM_CONFIG_DIR_NAME": false,
  "FIXED_CUSTOM_CONSOLE_ID": false,
  "FIXED_CUSTOM_TRIAL_STAGES": [
    {
      "daysRemaining": 10,
      "msg": "state_1",
      "priority": "information",
      "tagText": "free_trial",
      "tagVariant": "rose"
    },
    {
      "daysRemaining": 1,
      "msg": "state_2",
      "priority": "information",
      "tagText": "trial_ending",
      "tagVariant": "rose"
    },
    {
      "daysRemaining": 0,
      "msg": "state_3",
      "priority": "high",
      "tagText": "suspended",
      "tagVariant": "red"
    }
  ],
  "FIXED_ENABLE_GREEN_DISCOUNT": false,
  "FIXED_ENABLE_FREE_TRIAL_DIALOG": false,
  "FIXED_ENABLE_ORGANIZATION_FIRST_ONBOARDING": false,
  "FIXED_ENABLE_MULTIVERSION_DEPLOYMENT": false,
  "FIXED_ENABLE_ORGANIZATION_PLANS_PERMISSION": true,
  "FIXED_ENABLE_PROJECT_ACCESS_SELECT": false,
  "FIXED_ENABLE_PROJECT_SETUP_TIPS": false,
  "FIXED_ENABLE_PROJECT_SETUP_WIZARD": true,
  "FIXED_ENABLE_SUBSCRIBE_FLOW": false,
  "FIXED_ENABLE_USAGE_BASED_BILLING_PAGES": false,
  "FIXED_ENABLE_CONTINUOUS_PROFILING_SELLABLE": false,
  "FIXED_ENABLE_CUSTOM_BANNER_MESSAGE": false,
  "FIXED_ENABLE_REACTIVATE_TRIAL": false,
  "VERSION_NUMBER": "3.3.0"
}